// components/PublicRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children, redirectToDashboard = true }) => {
  const token = localStorage.getItem('token');
  
  // Only redirect if this route should be protected
  if (redirectToDashboard && token) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default PublicRoute;